import { useEffect, useState } from "react";

import debounce from "lodash/debounce";
import { inBrowser } from "core-web/constants";

type InvokeResizeFunction = (e?: Event) => void;

const useScrollbarWidth = () => {
    const getScrollbarWidth = () => (inBrowser ? window.innerWidth - document.documentElement.clientWidth : 0);

    const [scrollbar, setScrollbar] = useState(getScrollbarWidth());

    const handleWindowResize: InvokeResizeFunction = debounce(() => {
        setScrollbar(getScrollbarWidth());
    }, 500);

    // this needed to ensure the scrollbar width in case hook called before the DOM is ready
    useEffect(() => {
        if (!scrollbar) {
            setScrollbar(getScrollbarWidth());
        }
    }, [scrollbar]);

    useEffect(() => {
        const invokeHandleWindowResize = (e?: Event) => handleWindowResize(e);

        window.addEventListener("resize", invokeHandleWindowResize);

        return () => {
            window.removeEventListener("resize", invokeHandleWindowResize);
        };
    }, []);

    return { update: handleWindowResize, scrollbarWidth: scrollbar };
};

export default useScrollbarWidth;
